import React, { useEffect, useState } from "react";
import Slider from "react-slick"; // Import thư viện react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; // Import CSS mặc định cho slider
import slide1 from "../../assets/images/slides/slide1.webp";
import slide2 from "../../assets/images/slides/slide2.webp";
import slidemb from "../../assets/images/slides/slideMB.webp";
import slidemb2 from "../../assets/images/slides/slideMB2.webp";
import slidemb3 from "../../assets/images/slides/slideMB3.webp";
import slide3 from "../../assets/images/slides/slide3.webp";
import slidemb3_1 from "../../assets/images/slides/slideMB3_1.webp";
import logo from "../../assets/images/logo.svg";
import styles from "../../assets/styles/_home.module.scss";
import BtnLearnMore from "../common/btnLearnMore";
import thumbProduct1 from "../../assets/images/productPage/product-bottle.png";
import thumb1Product1 from "../../assets/images/productPage/product-bottle1.png";
import thumb2Product1 from "../../assets/images/productPage/product-bottle2.png";
import thumb3Product1 from "../../assets/images/productPage/product-bottle3.png";
import thumb4Product1 from "../../assets/images/productPage/product-bottle4.png";
import thumb5Product1 from "../../assets/images/productPage/product-bottle5.png";
import thumbProduct2 from "../../assets/images/productPage/thumbProduct2.png";
import thumb1Product2 from "../../assets/images/productPage/thumb1Product2.png";
import thumb2Product2 from "../../assets/images/productPage/thumb2Product2.png";
import thumb3Product2 from "../../assets/images/productPage/thumb3Product2.png";
import thumb4Product2 from "../../assets/images/productPage/thumb4Product2.png";
import thumb5Product2 from "../../assets/images/productPage/thumb5Product2.png";
import shopLst1 from "../../assets/images/products/shopLst1.png";
import shopLst2 from "../../assets/images/products/shopLst2.png";
import topic from "../../assets/images/topic.png";
import WaterWave from "react-water-wave";
import FadeInSection from "../common/FadeInSection";
import MaskBgAnimation from "../common/MaskBgAnimation";
import { useNavigate } from "react-router-dom";
import { getTopics } from "../../api/topic";
import { LoadingSpin } from "../LoadingSpin";
import dayjs from "dayjs";
import logoKV from "../../assets/images/KV/logoKV.png";

const HomePageComponent = () => {
  const navigate = useNavigate();
  const settingsSlideProduct = {
    infinite: true, // Lặp lại vô hạn
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0, // Tăng thời gian dừng slide
    speed: 10000, // Làm chậm tốc độ trượt
    cssEase: "linear", // Giúp trượt mượt hơn
    pauseOnHover: false, // Không dừng khi hover
    // draggable: true, // Không cho người dùng kéo tay
    // swipe: true, // Không cho vuốt
    // touchMove: true, // Không cho di chuyển bằng touch
    responsive: [
      {
        breakpoint: 1024, // Khi màn hình nhỏ hơn 768px
        settings: {
          slidesToShow: 4, // Hiển thị 3 slide
        },
      },
      {
        breakpoint: 800, // Khi màn hình nhỏ hơn 768px
        settings: {
          slidesToShow: 3, // Hiển thị 3 slide
        },
      },
      {
        breakpoint: 577, // Khi màn hình nhỏ hơn 577px
        settings: {
          slidesToShow: 2, // Hiển thị 2 slide
          centerMode: true,
        },
      },
    ],
  };
  const settings = {
    dots: true, // Hiển thị dot điều hướng
    infinite: true, // Lặp lại vô hạn
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: null,
    prevArrow: null,
  };
  const slides = [
    {
      id: 3,
      image: slide3,
      imageMB: slidemb3_1,
      title: "Slide 3",
    },
    {
      id: 1,
      image: slide1,
      imageMB: slidemb3,
      title: "Slide 1",
    },
    {
      id: 2,
      image: slide2,
      imageMB: slidemb2,
      title: "Slide 2",
    },
  ];
  const products = [
    {
      id: 1,
      thumb: thumbProduct1,
      title1: "ウォーターコートシャンプー",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product1,
      title1: "ウォーターコートトリートメント",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product1,
      title1: "ウォーターコートヘアオイル",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product1,
      title1: "ウォーターコートヘアミルク",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product1,
      title1: "ウォーターコートシャンプー",
      title2: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product1,
      title1: "ウォーターコートトリートメント",
      title2: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380g",
    },
    {
      id: 1,
      thumb: thumbProduct2,
      title1: "ウォーターコートシャンプー",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product2,
      title1: "ウォーターコートトリートメント",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product2,
      title1: "ウォーターコートヘアオイル",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product2,
      title1: "ウォーターコートヘアミルク",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product2,
      title1: "ウォーターコートシャンプー",
      title2: "スリークモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product2,
      title1: "ウォーターコートトリートメント",
      title2: "スリークモイスト",
      capacity: "1,210",
      volume: "380g",
    },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    const getDataTopics = async () => {
      setIsLoading(true);
      try {
        const topics = await getTopics(1, 3);
        setTopics(topics.contents);
      } catch (error) {
        alert("トピックの取得に失敗しました");
      } finally {
        setIsLoading(false);
      }
    };
    getDataTopics();
  }, []);

  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".animation_border_bottom");

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        console.log(inViewport);
        if (inViewport) {
          element.classList.add("animatioTitle");
        } else {
          element.classList.remove("animatioTitle");
        }
      });

      const elementsBlock2 = document.querySelectorAll(".block2");

      elementsBlock2.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        console.log(inViewport);
        if (inViewport) {
          element.classList.add(styles.animation);
        } else {
          element.classList.remove(styles.animation);
        }
      });
    };
    // Lắng nghe sự kiện scroll
    window.addEventListener("scroll", handleScroll);

    // Gọi kiểm tra ban đầu
    handleScroll();

    // Dọn dẹp sự kiện khi component bị hủy
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  return (
    <div className={`${styles.homePage} homePage`}>
      <div className={styles.slideBaner}>
        <Slider {...settings}>
          {slides.map((slide) => (
            <div className={styles.itemSlide}>
              {!isMobile && (
                <WaterWave
                  className="water-wave-canvas"
                  imageUrl={slide.image}
                  dropRadius={20}
                  perturbance={0.03}
                  resolution={256}
                  style={{
                    backgroundSize: "contain",
                  }}
                >
                  {(methods) => (
                    <div className={styles.contentVoid}>
                      {slide.id === 3 && (
                        <div className={styles.contentVoidWrap}>
                          <div className={styles.contentTop}>
                            {/* <span>髪質別に､うるおい満ちる髪へ｡</span> */}
                            <img src={logoKV} alt="" />
                          </div>
                          <div className={styles.contentMiddle}>
                            {/* <span>*</span> <br /> */}
                            {/* <span>美容酸素水シャンプー</span> */}
                          </div>
                          <div className={styles.contentBottom}>
                            ＊水､酸素､乳酸桿菌､加水分解コラーゲン発酵液エキス､ヒアルロン酸Na､ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分(全て保湿成分)
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </WaterWave>
              )}
              {isMobile && (
                // ------------------ on Animation
                // <WaterWave
                //   className="water-wave-canvas"
                //   imageUrl={slide.imageMB}
                //   dropRadius={10}
                //   perturbance={0.01}
                //   resolution={200}
                //   style={{
                //     backgroundSize: "cover",
                //     backgroundPosition: "center center",
                //     aspectRatio: 375 / 569,
                //   }}
                // >
                //   {(methods) => (
                // <div className={styles.contentVoid}>
                //   {slide.id === 3 && (
                //     <div className={styles.contentVoidWrap}>
                //       <div className={styles.contentTop}>
                //         <img src={logoKV} alt="" />
                //       </div>
                //       <div className={styles.contentMiddle}>
                //         <span>*</span> <br />
                //         <span>美容酸素水シャンプー</span>
                //       </div>
                //       <div className={styles.contentBottom}>
                //         ＊水､酸素､乳酸桿菌､加水分解コラーゲン発酵液エキス､ヒアルロン酸Na､{" "}
                //         <br />{" "}
                //         ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分(全て保湿成分)
                //       </div>
                //     </div>
                //   )}
                // </div>
                //   )}
                // </WaterWave>
                // ------------------ off Animation
                <div
                  className="water-wave-canvas"
                  style={{
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    aspectRatio: 375 / 569,
                    backgroundImage: `url(${slide.imageMB})`,
                  }}
                >
                  <div className={styles.contentVoid}>
                    {slide.id === 3 && (
                      <div className={styles.contentVoidWrap}>
                        <div className={styles.contentTop}>
                          <img src={logoKV} alt="" />
                        </div>
                        <div className={styles.contentMiddle}>
                          {/* <span>*</span> <br />
                          <span>美容酸素水シャンプー</span> */}
                        </div>
                        <div className={styles.contentBottom}>
                          ＊水､酸素､乳酸桿菌､加水分解コラーゲン発酵液エキス､ヒアルロン酸Na､{" "}
                          <br />{" "}
                          ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分(全て保湿成分)
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
      <div className={styles.marginBox}></div>

      <div className={styles.block1}>
        {!isMobile && (
          <>
            <div className={styles.itemContent}></div>
            <div className={styles.itemContent}>
              <div className={`${styles.titleRight} animation_border_bottom`}>
                CONCEPT
              </div>
            </div>
          </>
        )}
        <div className={styles.itemContent}>
          <FadeInSection>
            <div className={styles.contentWrapLeft}>
              <div className={styles.titleLeft}>
                自分の髪に、
                <br /> 本当に合うものを。
              </div>
              <div className={styles.desLeft}>
                コラーゲン*1溶け込む美容酸素水※で髪の保水パック
              </div>
              <div className={styles.contentLeft}>
                ＜シャンプー・トリートメント・ヘアミルク＞ <br />
                *1乳酸桿菌／加水分解コラーゲン発酵液エキス（保湿成分）
                <br />
                ※水、酸素、*1、ヒアルロン酸Na、ヒアルロン酸ヒドロキシプロピルトリモニウムの複合成分（全て保湿成分）
                <br />
                ＜ヘアオイル＞
                <br />
                *1イソステアロイル加水分解コラーゲンAMPD（保湿成分）
                <br />
                ※水、酸素、*1、ヒアルロン酸Naの複合成分（全て保湿成分）
              </div>
            </div>
          </FadeInSection>
        </div>
        {isMobile && (
          <>
            <div className={styles.marginBox25}></div>

            <div className={styles.itemContent}>
              <div className={`${styles.titleRight} animation_border_bottom`}>
                CONCEPT
              </div>
            </div>
          </>
        )}
        <div className={styles.itemContent}>
          <FadeInSection>
            {/* <div className={styles.subTitleRight}>髪質別に、うるおいめぐる</div> */}
            <div className={styles.textRight}>
              {isMobile ? (
                <>
                  毎日毎秒の呼吸で
                  <br />
                  酸素がわたしたちの体に
                  <br />
                  栄養をめぐらせるように
                  <br />
                  美容酸素水※がパサついた髪の毛を
                  <br />
                  奥深くまで水分で満たします
                  <br />
                  毛先が広がりやすい太髪の方
                  <br />
                  毛先がからまりやすい細髪の方
                  <br />
                  どれを試しても、なかなか実感できない
                  <br />
                  何を使ったら良いかわからない、という方へ
                  <br />
                  それぞれの髪質に合わせて
                  <br />
                  最適な仕上がりを提供します
                </>
              ) : (
                <>
                  毎日毎秒の呼吸で
                  <br />
                  酸素がわたしたちの体に栄養をめぐらせるように
                  <br />
                  美容酸素水※がパサついた髪の毛を奥深くまで
                  <br />
                  水分で満たします
                  <br />
                  毛先が広がりやすい太髪の方
                  <br />
                  毛先がからまりやすい細髪の方
                  <br />
                  どれを試しても、なかなか実感できない
                  <br />
                  何を使ったら良いかわからない、という方へ
                  <br />
                  それぞれの髪質に合わせて最適な仕上がりを提供します
                </>
              )}

              <div className={styles.center}>
                <p>うるおいめぐる髪の深呼吸</p>
                <img src={logo} alt="" />
                <BtnLearnMore
                  color="#5CCEFF66"
                  baseColor="#5CCEFF"
                  action={() => navigate("/concept")}
                >
                  LEARN MORE
                </BtnLearnMore>
              </div>
            </div>
          </FadeInSection>
        </div>
      </div>

      <div className={styles.marginBox}></div>

      <div className={`${styles.block2} block2`}>
        <div className={styles.titleWrap}>
          <div className={`${styles.title} animation_border_bottom`}>
            PRODUCT
          </div>
        </div>
        <MaskBgAnimation>
          <div className={styles.marginBox25}></div>

          <div
            className={styles.titleWrap}
            style={{ opacity: 0, position: "relative" }}
          >
            <div className={`${styles.title} animation_border_bottom`}>
              PRODUCT
            </div>
          </div>
          <div className={styles.listProduct}>
            <Slider {...settingsSlideProduct}>
              {products.map((product) => (
                <>
                  <div className={styles.itemProduct}>
                    <div className={styles.imageProduct}>
                      <img src={product.thumb} alt="" />
                    </div>
                    <div className={styles.titleProduct}>{product.title1}</div>
                    <div className={styles.desProduct}>{product.title2}</div>
                  </div>
                </>
              ))}
            </Slider>
          </div>
          <FadeInSection>
            <div className={styles.btn}>
              <BtnLearnMore
                color="#5CCEFF66"
                baseColor="#5CCEFF"
                action={() => navigate("/products")}
              >
                LEARN MORE
              </BtnLearnMore>
            </div>
          </FadeInSection>
          <div className={styles.marginBox25}></div>
        </MaskBgAnimation>
      </div>
      {/* {!isMobile && <div className={styles.marginBox}></div>} */}
      <div className={styles.marginBox}></div>
      <div className={styles.marginBox}></div>

      <div className={styles.block3}>
        <div className={styles.imgLst}>
          <FadeInSection>
            <img src={shopLst1} alt="" />
          </FadeInSection>
        </div>
        <div className={styles.titleWrap_mobile}>
          <div className={`${styles.title} animation_border_bottom`}>
            SHOP LIST
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.titleWrap}>
            <div className={`${styles.title} animation_border_bottom`}>
              SHOP LIST
            </div>
          </div>
          <div className={styles.btn}>
            <FadeInSection>
              <BtnLearnMore
                color="#5CCEFF66"
                baseColor="#5CCEFF"
                action={() => navigate("/shop")}
              >
                お取り扱い店舗一覧
              </BtnLearnMore>
            </FadeInSection>
          </div>
        </div>
      </div>
      <div className={styles.marginBox}></div>
      <div className={`${styles.block3} ${styles.reverse}`}>
        <div className={styles.titleWrap_mobile}>
          <div className={`${styles.title} animation_border_bottom`}>FAQ </div>
        </div>
        <div className={styles.content}>
          <div className={styles.titleWrap}>
            <div className={`${styles.title} animation_border_bottom`}>FAQ</div>
          </div>
          <FadeInSection>
            <div className={styles.btn}>
              <BtnLearnMore
                color="#5CCEFF66"
                baseColor="#5CCEFF"
                action={() => navigate("/faq")}
              >
                よくあるご質問
              </BtnLearnMore>
            </div>
          </FadeInSection>
        </div>
        <div className={styles.imgLst}>
          <FadeInSection>
            <img src={shopLst2} alt="" />
          </FadeInSection>{" "}
        </div>
      </div>
      <div className={styles.marginBox}></div>
      <div className={styles.marginBox25}></div>
      {!isMobile && <div className={styles.marginBox}></div>}

      <FadeInSection>
        <div className={styles.block4}>
          <div className={styles.titleWrap}>
            <div className={`${styles.title}`}>TOPICS</div>
          </div>
          {isLoading && <LoadingSpin />}
          {topics.length === 0 && !isLoading && (
            <div>
              <p style={{ color: "#fff" }}>まだ記事はありません。</p>
            </div>
          )}
          <div className={styles.listTopics}>
            {topics.map((topic) => (
              <div
                className={styles.itemTopics}
                key={topic.id}
                onClick={() => navigate(`/topic-detail/${topic.id}`)}
              >
                <div className={styles.imageTopics}>
                  <img src={topic.thumbnail.url} alt="" />
                </div>
                <div className={styles.titleTopics}>
                  {dayjs(topic.publishedAt).format("YYYY.MM.DD")}
                </div>
                <div className={styles.desTopics}>{topic.title}</div>
              </div>
            ))}
          </div>
        </div>
      </FadeInSection>
      <div className={styles.marginBox}></div>
      <div className={styles.marginBox25}></div>
      {!isMobile && <div className={styles.marginBox}></div>}
    </div>
  );
};

export default HomePageComponent;
